/* Start: API Constants */
/* Comment all but the variables needed for your current build. */

/* Dev (Unused) */
//const API_ENDPOINT = 'https://l0mzqyaiuh.execute-api.us-east-1.amazonaws.com';
//export const STAGE = 'dev';

/* Lower */
//const API_ENDPOINT = 'https://81li321ii4.execute-api.us-east-1.amazonaws.com';
//export const STAGE = 'dev';

/* Upper */
const API_ENDPOINT = 'https://7xq2ugsfyk.execute-api.us-east-1.amazonaws.com';
export const STAGE = 'prod';

/* End: API Constants */

const API_ENDPOINT_STAGE = `${API_ENDPOINT}/${STAGE}`;

export const SIGNED_URL_ENDPOINT = `${API_ENDPOINT_STAGE}/upload/file`;

export const UPLOAD_METADATA_ENDPOINT = `${API_ENDPOINT_STAGE}/upload/metadata`;

const SEARCH_ENDPOINT = `${API_ENDPOINT_STAGE}/search`;

export const MAX_SEARCH_RESULTS = 10000;
export const DECODE_SEARCH_RESULT_BODY = true;

export const SEARCH_ENDPOINT_DECISIONS = `${SEARCH_ENDPOINT}/decisions`;
export const SEARCH_ENDPOINT_FILINGS = `${SEARCH_ENDPOINT}/filings`;
export const SEARCH_ENDPOINT_NEWS = `${SEARCH_ENDPOINT}/news`;
export const SEARCH_ENDPOINT_TRANSCRIPTS = `${SEARCH_ENDPOINT}/transcripts`;
export const SEARCH_ENDPOINT_DOCKETS = `${SEARCH_ENDPOINT}/dockets`;
export const SEARCH_ENDPOINT_RECORDATIONS = `${SEARCH_ENDPOINT}/recordations`;
export const SEARCH_ENDPOINT_RECORDATION_PARTIES = `${SEARCH_ENDPOINT}/recordationParty`;
export const SEARCH_ENDPOINT_BY_DATE = `${SEARCH_ENDPOINT}/byDate`;
export const SEARCH_ENDPOINT_SERVICE_LIST = `${SEARCH_ENDPOINT}/serviceList`;
export const SEARCH_ENDPOINT_ENVIRONMENTAL_COMMENTS = `${SEARCH_ENDPOINT}/environmentalComments`;
export const SEARCH_ENDPOINT_ALL_DOCUMENTS = `${SEARCH_ENDPOINT}/documents`;

export const CONTENT_TYPE_HEADER = "Content-Type";

export const RESPONSE_START_INDEX_FIELD = "startIndex";
export const RESPONSE_BATCH_SIZE_FIELD = "batchSize";
export const RESPONSE_TOTAL_COUNT_FIELD = "totalCount";
export const RESPONSE_DATA_FIELD = "data";
export const RESPONSE_DATA_SUBSET_FIELD = "dataSubset";
export const RESPONSE_STATUS_FIELD = "status";
export const RESPONSE_FIELD = "response";
